<template>
  <div class="my-task-page">
    <!-- 状态筛选 -->
    <div class="status-tabs">
      <div
        v-for="tab in statusTabs"
        :key="tab.value"
        class="tab-item"
        :class="{ active: activeTab === tab.value }"
        @click="switchTab(tab.value)"
      >
        {{ tab.text }}
      </div>
    </div>

    <!-- 搜索行 -->
    <div class="search-row">
      <div class="search-box">
        <van-icon name="search" size="20" color="#999" />
        <input
          v-model="searchText"
          class="search-input"
          type="text"
          placeholder="请输入企业或岗位名称"
        />
        <van-icon v-if="searchText" name="clear" size="20" color="#c8c9cc" class="search-clear" @click="clearSearch" />
        <van-button class="search-btn" size="small" round @click="onSearch">搜索</van-button>
      </div>
    </div>

    <!-- 任务列表（加载更多） -->
    <div class="task-list">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        :immediate-check="false"
        @load="onLoad"
      >
        <div v-for="item in displayList" :key="item.id" class="task-card">
          <div class="task-info">
            <div class="task-title">{{ item.projectName }}</div>
            <div class="task-company">发布企业：{{ item.merName }}</div>
            <div class="task-status">
              状态：<span :class="'status-' + statusClass(item.taskStatus)">{{ statusText(item.taskStatus) }}</span>
            </div>
          </div>
          <div class="task-action">
            <van-button v-if="item.taskStatus === 1" class="btn-sign" round size="small" @click="onSign(item)">立即签约</van-button>
            <van-button v-if="item.taskStatus === 2" class="btn-record" round size="small" plain type="info" @click="onAddRecord(item)">添加服务记录</van-button>
          </div>
        </div>
      </van-list>

      <!-- 空状态 -->
      <van-empty description="暂无任务" v-if="finished && !displayList.length" />
    </div>

    <footer-menu></footer-menu>
  </div>
</template>
<script>
import footerMenu from '@/components/footer/FooterMenu'
import requestHomeAPI from '@/axios/HomeApi'

export default {
  name: 'MyTask',
  components: {
    footerMenu
  },
  data () {
    return {
      // 状态筛选（value 与接口 taskStatus 对应：0待审核 1待签约 2已签约 3未通过）
      statusTabs: [
        { text: '全部', value: -1 },
        { text: '待审核', value: 0 },
        { text: '待签约', value: 1 },
        { text: '服务中', value: 2 }
      ],
      activeTab: -1, // 默认全部
      // 搜索关键字
      searchText: '',
      // 列表分页状态
      list: [],
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 10
    }
  },
  computed: {
    // 展示列表：接口暂无搜索参数，关键字在已加载数据中本地过滤
    displayList () {
      const keyword = this.searchText.trim()
      if (!keyword) {
        return this.list
      }
      return this.list.filter(item =>
        (item.projectName || '').indexOf(keyword) > -1 || (item.merName || '').indexOf(keyword) > -1
      )
    }
  },
  created () {
    this.resetList()
  },
  methods: {
    // 状态文案
    statusText (status) {
      const map = {
        0: '待审核',
        1: '待签约',
        2: '已签约',
        3: '未通过'
      }
      return map[status] !== undefined ? map[status] : status
    },
    // 状态样式类
    statusClass (status) {
      const map = {
        0: 'pending',
        1: 'toSign',
        2: 'serving',
        3: 'rejected'
      }
      return map[status] || 'pending'
    },
    // van-list 触底加载一页
    onLoad () {
      this.loading = true
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      // 全部(-1)不传 taskStatus，其余状态传对应数字
      if (this.activeTab !== -1) {
        params.taskStatus = this.activeTab
      }
      console.log('请求参数 taskStatus:', this.activeTab, params)
      requestHomeAPI.taskList(params).then(res => {
        if (res.data.code === '0000') {
          const data = res.data.data || {}
          const rows = data.rows || []
          // 追加到列表末尾（加载更多）
          this.list = this.list.concat(rows)
          const total = data.total || 0
          this.pageNum++
          // 结束条件：数据到齐，或本页不足一页（服务端 total 与实际条数不一致时防止无限翻页）
          if (this.list.length >= total || rows.length < this.pageSize) {
            this.finished = true
          }
        } else {
          this.finished = true
          this.$notify({ type: 'danger', message: res.data.message })
        }
      }).catch(() => {
        this.finished = true
        this.$notify({ type: 'danger', message: '加载失败，请重试' })
      }).finally(() => {
        this.loading = false
      })
    },
    // 重置列表并重新加载
    resetList () {
      this.list = []
      this.pageNum = 1
      this.finished = false
      this.onLoad()
    },
    // 切换状态
    switchTab (value) {
      console.log('切换状态 value:', value, '当前 activeTab:', this.activeTab)
      if (this.activeTab === value) {
        return
      }
      this.activeTab = value
      this.resetList()
    },
    // 搜索
    onSearch () {
      this.resetList()
    },
    // 清空搜索关键字并加载全部结果
    clearSearch () {
      this.searchText = ''
      this.resetList()
    },
    // 立即签约：跳转到签约页面（我的信息页），content 由路由守卫写入 MERNO
    onSign (item) {
      const merNo = item.merNo || ''
      this.$router.push({
        path: '/mine/userInfo',
        query: { content: merNo }
      })
    },
    // 添加服务记录
    onAddRecord (item) {
      console.log('我的任务单项结果', item)
      // 跳转到添加服务记录页，携带任务信息（id 字段后端补充后自动生效）
      this.$router.push({
        path: '/serviceRecordAdd',
        query: {
          merId: item.merId || '',
          projectId: item.projectId || '',
          registPersonId: item.registPersonId || '',
          projectName: item.projectName,
          merName: item.merName
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
/*
 * 注意：项目 postcss 按 750 设计稿宽度将 px 自动转成 vw（src 代码），
 * 即源码数值是设计稿坐标，实际渲染大小 = 数值 ÷ 2。
 */
.my-task-page {
  min-height: 100%;
  background: #f5f5f5;
}

/* 状态筛选 */
.status-tabs {
  display: flex;
  padding: 0 20px;
  background: #fff;

  .tab-item {
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 88px;
    font-size: 30px;
    color: #666;

    &.active {
      color: #e92504; /* rgb(233, 37, 4) */
      font-weight: 600;

      /* 底部指示条 */
      &::after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: 8px;
        transform: translateX(-50%);
        width: 48px;
        height: 6px;
        border-radius: 3px;
        background: #e92504;
      }
    }
  }
}

/* 搜索行 */
.search-row {
  padding: 20px 32px;
  background: #fff;

  .search-box {
    display: flex;
    align-items: center;
    height: 96px;
    padding: 0 16px 0 24px;
    background: #f5f5f5;
    border-radius: 999px;

    .search-input {
      flex: 1;
      border: none;
      outline: none;
      background: transparent;
      margin-left: 16px;
      font-size: 30px;
      color: #323233;

      &::placeholder {
        color: #c8c9cc;
      }
    }

    /* 清空搜索图标 */
    .search-clear {
      margin: 0 16px 0 8px;
    }

    .search-btn.van-button {
      flex-shrink: 0;
      height: 80px;
      line-height: 80px;
      padding: 0 40px;
      font-size: 30px;
      border: none;
      border-radius: 999px;
      color: #e92504;
      border: 1px solid #e92504;

    }
  }
}

/* 任务列表 */
.task-list {
  padding-top: 20px;
}

.task-card {
  display: flex;
  align-items: center;
  margin: 0 20px 20px;
  padding: 28px 32px;
  background: #fff;
  border-radius: 16px;
  text-align: left;

  .task-info {
    flex: 1;
    min-width: 0;

    .task-title {
      font-size: 36px;
      font-weight: 600;
      color: #323233;
      margin-bottom: 8px;
    }

    .task-company {
      font-size: 28px;
      color: #666;
      line-height: 44px;
    }

    .task-status {
      font-size: 28px;
      color: #666;
      line-height: 44px;

      .status-pending {
        color: #ff976a;
      }

      .status-toSign {
        color: #e92504;
      }

      .status-serving {
        color: #07c160;
      }

      .status-rejected {
        color: #ee0a24;
      }
    }
  }

  /* 右侧按钮（垂直居中） */
  .task-action {
    flex-shrink: 0;
    margin-left: 20px;

    .btn-sign {
      font-size: 26px;
      height: 60px;
      padding: 0 24px;
      border-radius: 999px;
      background: transparent;
      border-color: #e92504;
      color: #e92504;
    }

    .btn-record {
      font-size: 26px;
      height: 60px;
      padding: 0 24px;
      border-radius: 999px;
    }
  }
}
</style>
